<template>
    <svg class="file-type-icon" :width="size" :height="size" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
        <!-- 纸张 -->
        <path d="M8 5.5A3.5 3.5 0 0 1 11.5 2h16.2L42 16.3v26.2A3.5 3.5 0 0 1 38.5 46h-27A3.5 3.5 0 0 1 8 42.5V5.5z"
            :fill="color" />
        <!-- 折角 -->
        <path d="M27.7 2L42 16.3H27.7V2z" fill="#ffffff" fill-opacity="0.35" />
        <!-- 扩展名 -->
        <text x="25" y="34" text-anchor="middle" :font-size="labelSize" font-weight="700" letter-spacing="0.4"
            fill="#ffffff" font-family="'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif">{{ label }}</text>
    </svg>
</template>

<script>
// 类型分组：便于扩展和维护
const TYPE_GROUPS = {
    image: ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp', 'svg', 'ico', 'tif', 'tiff', 'heic'],
    video: ['mp4', 'mov', 'avi', 'mkv', 'flv', 'wmv', 'webm', 'm4v', 'mpg', 'mpeg', 'rmvb'],
    audio: ['mp3', 'wav', 'flac', 'aac', 'ogg', 'm4a', 'wma', 'ape', 'mid'],
    pdf: ['pdf'],
    word: ['doc', 'docx', 'rtf', 'odt', 'wps'],
    excel: ['xls', 'xlsx', 'csv', 'ods', 'et'],
    ppt: ['ppt', 'pptx', 'odp', 'dps'],
    archive: ['zip', 'rar', '7z', 'tar', 'gz', 'bz2', 'xz', 'tgz', 'iso', 'jar'],
    package: ['exe', 'msi', 'rpm', 'deb', 'dmg', 'pkg', 'apk', 'appimage', 'snap', 'bat', 'cmd', 'com'],
    code: [
        'json', 'xml', 'yaml', 'yml', 'js', 'jsx', 'ts', 'tsx', 'vue', 'java', 'py', 'go', 'php', 'c', 'cpp', 'h',
        'hpp', 'cs', 'rb', 'rs', 'kt', 'swift', 'sql', 'html', 'htm', 'css', 'scss', 'less', 'sh', 'bash', 'ps1',
        'properties', 'ini', 'conf', 'toml'
    ],
    design: ['psd', 'ai', 'xd', 'sketch', 'fig', 'cdr'],
    font: ['ttf', 'otf', 'woff', 'woff2', 'eot'],
    db: ['db', 'sqlite', 'sqlite3', 'mdb', 'accdb'],
    text: ['txt', 'md', 'markdown', 'log', 'text']
};

// 各类型主题色
const TYPE_COLORS = {
    image: '#0ea5e9',
    video: '#8b5cf6',
    audio: '#14b8a6',
    pdf: '#ef4444',
    word: '#2563eb',
    excel: '#16a34a',
    ppt: '#ea580c',
    archive: '#f59e0b',
    package: '#64748b',
    code: '#7c3aed',
    design: '#db2777',
    font: '#0284c7',
    db: '#0891b2',
    text: '#94a3b8'
};

// 少数过长或不好识别的扩展名做别名，其余直接取扩展名
const LABEL_ALIAS = {
    markdown: 'MD',
    jpeg: 'JPG',
    yaml: 'YML',
    sqlite3: 'DB'
};

const EXT_TYPE_MAP = {};
Object.keys(TYPE_GROUPS).forEach(type => {
    TYPE_GROUPS[type].forEach(ext => {
        EXT_TYPE_MAP[ext] = type;
    });
});

export default {
    name: 'FileTypeIcon',
    props: {
        // 文件名或扩展名
        name: {
            type: String,
            default: ''
        },
        // 图标尺寸（px）
        size: {
            type: [Number, String],
            default: 56
        }
    },
    computed: {
        ext() {
            let name = (this.name || '').trim();
            if (!name) {
                return '';
            }
            // 传入的本身就是扩展名时直接使用
            if (name.indexOf('.') < 0) {
                return name.toLowerCase();
            }
            return name.substring(name.lastIndexOf('.') + 1).toLowerCase();
        },
        type() {
            return EXT_TYPE_MAP[this.ext] || '';
        },
        // 图标上显示的扩展名，最多 4 个字符
        label() {
            if (!this.ext) {
                return 'FILE';
            }
            if (LABEL_ALIAS[this.ext]) {
                return LABEL_ALIAS[this.ext];
            }
            return this.ext.toUpperCase().substring(0, 4);
        },
        labelSize() {
            if (this.label.length >= 4) {
                return 11;
            }
            return this.label.length === 3 ? 12 : 14;
        },
        color() {
            return TYPE_COLORS[this.type] || '#94a3b8';
        }
    }
};
</script>

<style scoped>
.file-type-icon {
    display: block;
}
</style>
